import React from 'react'
import { TriageView } from './triage'
import { DetailView } from './detail'
import { RejectionReview } from './RejectionReview'
import { RejectionDetail } from './RejectionDetail'
import { SuppressionsView } from './SuppressionsView'

type DashboardProps = {
  path?: string
  advertiserDomain?: string
  uri?: string
  location?: {
    pathname: string
    search?: string
  }
}

type Tab = 'triage' | 'rejection-review' | 'suppressions'

const parseTab = (search: string | undefined): Tab => {
  if (!search) return 'triage'
  const params = new URLSearchParams(search)
  const t = params.get('tab')
  if (t === 'rejection-review') return 'rejection-review'
  if (t === 'suppressions') return 'suppressions'
  return 'triage'
}

export const AnomaliesDashboard = (props: DashboardProps) => {
  const pathname = props.location?.pathname || ''
  const isRejectionDetail = pathname.startsWith('/anomalies/rejection-review/')

  if (props.advertiserDomain && isRejectionDetail) {
    return (
      <RejectionDetail
        advertiserDomain={props.advertiserDomain}
        search={props.location?.search}
      />
    )
  }

  if (props.advertiserDomain) {
    return (
      <DetailView
        advertiserDomain={props.advertiserDomain}
        search={props.location?.search}
      />
    )
  }

  const tab = parseTab(props.location?.search)

  const setTab = (next: Tab) => {
    if (typeof window === 'undefined') return
    const params = new URLSearchParams(window.location.search)
    if (next === 'triage') params.delete('tab')
    else params.set('tab', next)
    const search = params.toString()
    const target = `/anomalies${search ? `?${search}` : ''}`
    if (window.location.pathname + window.location.search !== target) {
      window.history.pushState({}, '', target)
      // pushState doesn't fire popstate; dispatch one so @reach/router (and
      // hooks that mirror window.location) re-read the URL.
      window.dispatchEvent(new PopStateEvent('popstate'))
    }
  }

  return (
    <div className="anomalies-page anomalies-page-tabs-wrapper">
      <AnomaliesTabs tab={tab} onChange={setTab} />
      {tab === 'triage' && <TriageView />}
      {tab === 'rejection-review' && <RejectionReview />}
      {tab === 'suppressions' && <SuppressionsView />}
    </div>
  )
}

const AnomaliesTabs = (props: { tab: Tab; onChange: (t: Tab) => void }) => {
  const items: { value: Tab; label: string }[] = [
    { value: 'triage', label: 'Daily triage' },
    { value: 'rejection-review', label: 'Monthly rejection review' },
    { value: 'suppressions', label: 'Suppressions' },
  ]
  return (
    <div className="anomalies-page-tabs">
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          className={
            'anomalies-page-tab' +
            (props.tab === item.value ? ' active' : '')
          }
          onClick={() => props.onChange(item.value)}
        >
          {item.label}
        </button>
      ))}
    </div>
  )
}
